import Reflux from "reflux";

var SitePublishActions = Reflux.createActions([
  "changeView",
  "openDialog",
  "closeDialog",
  "publishSite",
  "publishBlog",
  "publishComplete",
  "generateBlogPreview",
]);

export default SitePublishActions;
